import React, { Component } from 'react';
import session from '../../utils/session';
import urlHandler from '../../utils/urlHandler';
import FinchButton from '../demo/FinchButton';

class LocationFinderQuery extends Component {
    constructor(props){
        super(props);

        this.onResponse = this.onResponse.bind(this);
        this.clickActions = this.clickActions.bind(this);
        this.inputChange = this.inputChange.bind(this);

        this.state = {
            processing: false,
            haveInput: false,
            error: null,
            response: null,
            responseVisible: false
        };
    }

    onResponse(response, arg1, http) {
        if (http !== 200 && http !== 250) {
            if (http === 429) {
                this.setState({
                    processing: false,
                    error: 'Too many requests: Rate limit exceeded.',
                    response: null,
                    responseVisible: false
                });
            } else {
                this.setState({
                    processing: false,
                    error: decodeURIComponent(response.error_message),
                    response: null,
                    responseVisible: false
                });
            }
        } else {
            this.setState({
                processing: false,
                error: null,
                responseVisible: true,
                response
            });
        }

    }

    clickActions() {
        if (this.state.responseVisible) {
            this.setState({
                response: null,
                responseVisible: false
            });
        } else if(session.isAuthenticated() && this.state.haveInput){
            if(this.state.processing === false && session.isAuthenticated()){
                this.setState({
                    processing: true
                });
            }
            var args = `query=${encodeURIComponent(this.refs.location.value)}`;
            urlHandler.sendRequest('location-finder', null, args, null, null, this.onResponse);
        }
    }

    inputChange(e) {
        this.setState({
            haveInput: this.refs.location.value.length > 0,
            error: null,
            response: null,
            responseVisible: false
        });
    }

    render() {
        const responseText = JSON.stringify(this.state.response, null, 4);
        const queryResponse = session.isAuthenticated()===true;

        return (
            <div>
                <div className="locationfinder-form-wrapper text-field">
                    <input type='text' className='locationfinder-form-field' ref='location' onChange={this.inputChange}/>
                    <span className='locationfinder-form-error'>{this.state.error}</span>
                </div>
                <br/>
                <div className='example-query-wrapper'>
                    <span>
                        <FinchButton processing = {this.state.processing} inactive={!session.isAuthenticated() || !this.state.haveInput} 
                            warning = {true} 
                            text = {this.state.responseVisible ? 'Hide Response' : 'Show Response'}  
                            submit={this.clickActions}/>
                        <span className='user-warning' hidden={queryResponse ? true:false}> You need to be logged in to see API Examples</span>
                    </span>
                    <div className='example-query-response' hidden={!session.isAuthenticated() === true || !this.state.responseVisible} >
                        <code id='text'>
                            <pre>{responseText}</pre>
                        </code>
                    </div>
                </div>
            </div>
        );
    }

}

export default LocationFinderQuery;